import { defineMessages } from 'react-intl';

export const rovoTemplatesCalloutMessages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createWithRovo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'conversation-assistant-blank-object-experience.rovo-templates-callout.title',
		defaultMessage: "Can't find what you're looking for?",
		description: 'Title for the Rovo promotional callout frame',
	},
	description: {
		id: 'conversation-assistant-blank-object-experience.rovo-templates-callout.description',
		defaultMessage: 'Get help structuring and accelerating your work with Rovo.',
		description: 'Description text for the Rovo promotional callout frame',
	},
	createWithRovo: {
		id: 'conversation-assistant-blank-object-experience.rovo-templates-callout.create-with-rovo',
		defaultMessage: 'Create with Rovo',
		description: 'Label for the Create with Rovo button',
	},
});

export const blankObjectExperienceModalMessages: {
	close: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	or: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	startFromTemplate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	import: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	close: {
		id: 'blank-object-experience-modal.close',
		defaultMessage: 'Close',
		description: 'Accessible label for the close button on the blank object experience modal',
	},
	or: {
		id: 'blank-object-experience-modal.or',
		defaultMessage: 'or',
		description: 'Divider text between prompts and footer actions',
	},
	startFromTemplate: {
		id: 'blank-object-experience-modal.start-from-template',
		defaultMessage: 'Start from a template',
		description: 'Button label to start from a template',
	},
	import: {
		id: 'blank-object-experience-modal.import',
		defaultMessage: 'Import',
		description: 'Button label to import content',
	},
});

export const smartPromptSkeletonMessages: {
	loadingSmartPrompt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	loadingSmartPrompt: {
		id: 'ai-mate.conversation-assistant-blank-object-experience.smart-prompt-skeleton.loading',
		defaultMessage: 'Loading smart prompt',
		description:
			'Accessible label for the skeleton loading placeholder while smart prompts are being fetched',
	},
});

export const smartPromptTemplatePreviewMessages: {
	basedOnTemplate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	basedOnTemplate: {
		id: 'conversation-assistant-blank-object-experience.templatePreview.basedOn',
		defaultMessage: 'Based on {templateName} template',
		description: 'Text indicating that the preview is based on a specific template',
	},
});

export const smartPromptsMoreButtonMessages: {
	moreButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	moreButton: {
		id: 'conversation-assistant-blank-object-experience.moreButton',
		defaultMessage: 'More',
		description: 'Label for the button that reveals additional smart prompts',
	},
});
